import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ExoForm from '../../../components/exo/ExoForm';
import { API_PATCH, DBRequest, useConfig } from '../../../api/api';

export const EmployeeSettings = ({ employeeInfo, onUpdateUser }) => {
  const { t } = useTranslation();
  const config = useConfig();

  const { preferences } = employeeInfo || {};

  const fields = [
    {
      label: t('Require a photo when clocking out'),
      type: 'checkbox',
      key: 'requirePhotoClockOut',
    },
  ];

  function handleSubmit(data) {
    const newAdditionalOptions = { ...employeeInfo?.preferences, ...data };

    DBRequest({
      config,
      path: `userpreferences/${employeeInfo?.preferences?.id}`,
      method: API_PATCH({ additionalOptions: newAdditionalOptions }),
      onResponse: (res) => {
        onUpdateUser({ ...employeeInfo, preferences: res.data || {} });
      },
    });
  }
  console.log(employeeInfo);

  return (
    <Box className="w-full max-w-[600px]">
      <ExoForm
        startDataCollection={preferences?.additionalOptions}
        fields={fields}
        onSubmit={handleSubmit}
      />
    </Box>
  );
};
